import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { toast } from "react-toastify";
import l from "components/util/l";

// The photo is taken in the page because a file input's `capture` only reaches the camera
// on a phone; a desktop browser opens the explorer instead.
const ConversationCamera = ({ onCancel, onCapture }) => {

  const videoRef = useRef(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => openCameraStream(videoRef, () => {
    toast(l("No se pudo acceder a la cámara%CH046"), { type: "warning" });
    onCancel();
  }), []);

  return createPortal(
    <div className="camera-capture-backdrop" onMouseDown={onCancel}>
      <div className="camera-capture bg-white border shadow p-3" onMouseDown={(e) => e.stopPropagation()}>

        <div className="camera-capture-preview mb-3">
          {!isReady && <i className="fas fa-spinner fa-pulse" />}
          <video ref={videoRef} autoPlay playsInline muted onLoadedMetadata={() => setIsReady(true)} />
        </div>

        <div className="d-flex justify-content-end">
          <button type="button" className="btn btn-sm btn-outline-secondary mr-2" onClick={onCancel}>
            {l("Cancelar%GA009")}
          </button>
          <button type="button" className="btn btn-sm btn-primary" disabled={!isReady}
            onClick={() => capturePhoto(videoRef.current, onCapture)}>
            <i className="fas fa-camera mr-2" />{l("Tomar foto%CH045")}
          </button>
        </div>

      </div>
    </div>,
    document.body
  );

};

// Returns the effect's cleanup: the stream is released on unmount, whichever way the user
// leaves — even when the permission is granted after they already cancelled.
const openCameraStream = (videoRef, onFailure) => {

  let stream = null;
  let isMounted = true;

  // Absent outside a secure context (plain http), where the browser hides the camera.
  if (!navigator.mediaDevices) return onFailure();

  navigator.mediaDevices
    .getUserMedia({ video: { facingMode: { ideal: "environment" } }, audio: false })
    .then((mediaStream) => {
      stream = mediaStream;
      if (!isMounted) return stopStream(stream);
      videoRef.current.srcObject = mediaStream;
    })
    .catch(() => isMounted && onFailure());

  return () => {
    isMounted = false;
    if (stream) stopStream(stream);
  };

};

const capturePhoto = (video, onCapture) => {
  const canvas = document.createElement("canvas");
  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;
  canvas.getContext("2d").drawImage(video, 0, 0);
  canvas.toBlob(onCapture, "image/jpeg", 0.92);
};

const stopStream = (stream) => stream.getTracks().forEach((track) => track.stop());

export default ConversationCamera;
